import { Box, Text } from '@chakra-ui/react';
import { Input, InputVariant } from '@pluxee-design-system/core';
import { InputControlProps } from '@pluxee-design-system/react-hook-form';
import { getVariant } from 'common/forms/utils';
import { ChangeEventHandler, useCallback } from 'react';
import { useController } from 'react-hook-form';

interface AccountNumberControlProps extends InputControlProps {
  format?: string;
}

export const formatValue = (rawValue: string, format?: string) => {
  if (rawValue === '') return '';

  let value = rawValue.replace(/\s/g, '');

  if (format && value.startsWith(format)) {
    value = value.substring(format.length);
  }

  return value;
};

const AccountNumberControl = ({
  control,
  disabled,
  isDisabled,
  format,
  name,
  mandatory,
  readonly,
  isReadOnly,
  rules,
  skipSuccess,
  skipVariant,
  onChange: _,
  ...inputProps
}: AccountNumberControlProps) => {
  const { field, fieldState, formState } = useController({
    name,
    control,
    rules,
  });
  const { onChange } = field;
  const { error } = fieldState;
  const variant = getVariant(
    formState,
    fieldState,
    isReadOnly ?? readonly,
    skipSuccess,
    skipVariant,
  );

  // handle any format to proper format
  const handleChange = useCallback<ChangeEventHandler<HTMLInputElement>>(
    (event) => {
      const value = formatValue(event.target.value, format);
      onChange(value);
    },
    [format, onChange],
  );

  return (
    <Box flex="2 0 auto">
      <Input
        type="text"
        mandatory={mandatory}
        name={field.name}
        onBlur={inputProps.onBlur ?? field.onBlur}
        onChange={handleChange}
        value={field.value}
        {...inputProps}
        disabled={variant !== InputVariant.READONLY && (disabled ?? isDisabled)}
        variant={variant}
        helpText={error?.message ?? inputProps.helpText}
        leftElement={
          format && (
            <Text variant="body.largeDemibold" color="semantic.text.primary">
              {format}
            </Text>
          )
        }
      />
    </Box>
  );
};

export default AccountNumberControl;
